import { q } from 'groqd'
import type { InferType } from 'groqd'

import { imageAsset } from '@/cms/helperTypes'

export const abstractProductQuery = q('*')
  .filter('_type == "abstractProduct" && _id == $id')
  .grab({
    _type: q.literal('abstractProduct'),
    market: q.string(),
    abstractProductKey: ['abstractProductKey.current', q.string()],
    defaultProduct: q('defaultProduct')
      .deref()
      .grab({
        productKey: q('productKey')
          .deref()
          .grab({
            productKey: ['productKey.current', q.string()],
          }),
        title: ['title[$lang]', q.string()],
        titleShort: ['titleShort[$lang]', q.string()],
        imageSquare: q('imageSquare').grab({
          _type: q.literal('image'),
          asset: q('asset').deref().grab(imageAsset),
        }),
        minMonthlyPremium: q.number(),
        minTotalMonthlyPremium: q.number().nullable(),
      }),
    website: q('website')
      .deref()
      .grab({
        slug: ['slug[$lang].current', q.string()],
        folder: ['folder[$lang]', q.string().nullable()],
      }),
    availableInEnvironments: q
      .array(q.union([q.literal('staging'), q.literal('production')]))
      .nullable(),
  })
  .slice(0)

export const mgaLightProductQuery = q('*')
  .filter('_type == "mgaLightProduct" && _id == $id')
  .grab({
    _type: q.literal('mgaLightProduct'),
    market: q.string(),
    mgaLightProductKey: ['mgaLightProductKey.current', q.string()],
    title: ['title[$lang]', q.string()],
    titleShort: ['titleShort[$lang]', q.string()],
    imageSquare: q('imageSquare').grab({
      _type: q.literal('image'),
      asset: q('asset').deref().grab(imageAsset),
    }),
    minMonthlyPremium: q.number(),
    website: q('website')
      .deref()
      .grab({
        slug: ['slug[$lang].current', q.string()],
        folder: ['folder[$lang]', q.string().nullable()],
      }),
    availableInEnvironments: q
      .array(q.union([q.literal('staging'), q.literal('production')]))
      .nullable(),
  })
  .slice(0)

export const productInfoAccordionQuery = q('*')
  .filter('_type == "product" && _id == $id')
  .grab(
    {},
    {
      '$itemKey != ""': {
        infoSectionsGroup: q('infoSectionsGroups')
          .filter()
          .grab({
            itemKey: q.string(),
            item: q('infoSections')
              .filter('itemKey == $itemKey')
              .grab({
                _key: q.string(),
                data: q('data')
                  .filter()
                  .grab({
                    _key: q.string(),
                    heading: ['heading[$lang]', q.string()],
                    subheading: ['subheading[$lang]', q.string().nullable()],
                    description: ['description[$lang]', q.string().nullable()],
                    icon: q
                      .union([
                        q.literal('checkMark'),
                        q.literal('crossMark'),
                        q.literal('plus'),
                        q.literal('info'),
                        q.literal('heart'),
                        q.literal('questionMark'),
                        q.literal('minus'),
                        q.literal('pencil'),
                        q.literal('document'),
                        q.literal('exclamationMark'),
                      ])
                      .nullable(),
                  }),
              })
              .slice(0),
          })
          .slice(0),
      },
      '$itemKey == ""': {
        faqs: q('faqs')
          .filter()
          .grab({
            _key: q.string(),
            heading: ['heading[$lang]', q.string()],
            subheading: ['subheading[$lang]', q.string().nullable()],
            description: ['description[$lang]', q.string().nullable()],
            icon: q
              .union([
                q.literal('checkMark'),
                q.literal('crossMark'),
                q.literal('plus'),
                q.literal('info'),
                q.literal('heart'),
                q.literal('questionMark'),
                q.literal('minus'),
                q.literal('pencil'),
                q.literal('document'),
                q.literal('exclamationMark'),
              ])
              .nullable(),
          }),
      },
    }
  )
  .slice(0)

export type Product = InferType<typeof abstractProductQuery>
